import { fetchApi, ADMIN_API } from '@/api/client'
import type { ReconRefreshAck, TableReconResponse, TableReconRow } from '../types'

const BASE = `${ADMIN_API}/admin/sync-validation`

/** List the account's tables with cached reconciliation counts (no engine queries fired). */
export async function getTableRecon(accId: number): Promise<TableReconResponse> {
  return fetchApi<TableReconResponse>(`${BASE}/${accId}`)
}

/** Fires the Mongo/StarRocks/warehouse count queries for one table (explicit user action). */
export async function syncTable(accId: number, table: string): Promise<TableReconRow> {
  const query = new URLSearchParams({ table })
  return fetchApi<TableReconRow>(`${BASE}/${accId}/sync?${query}`, { method: 'POST' })
}

/**
 * Triggers the full recon refresh — the same work as the nightly scheduled job — re-syncing cached
 * counts for every tracked table across all accounts. The run happens in the background and this
 * returns immediately (202); poll the list endpoint to see counts update as it progresses.
 */
export async function refreshAllRecon(): Promise<ReconRefreshAck> {
  return fetchApi<ReconRefreshAck>(`${BASE}/refresh`, { method: 'POST' })
}
